import PropTypes from 'prop-types';
// material
import { Box, Divider, Stack, Typography } from '@mui/material';

// ----------------------------------------------------------------------

LogoBSRE.propTypes = {
  sx: PropTypes.object
};

export default function LogoBSRE({ sx }) {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Box component="img" src="/static/logo-bsre.png" sx={{ ...sx }} />
      <Typography variant="body2">
        peladen.jogjaprov.go.id sudah mendukung tanda tangan elektronik dari Balai Sertifikasi
        Elektronik (BSrE) Badan Siber dan Sandi Negara (BSSN)
      </Typography>
    </Stack>
  );
}
